import servicesImg1 from "../assets/png/services1.jpg";
import servicesImg2 from "../assets/png/services2.jpg";

export const servicesData = {
  description1:
    "Oferuję szeroki zakres usług fizjoterapeutycznych, które są dopasowane do Twoich potrzeb.",
  description2:
    "Nasze spotkania są zaprojektowane, aby pomóc Ci osiągnąć swoje cele w bezpieczny i efektywny sposób.",
  cooperations: [
    "Mamy: Bycie mamą to wielkie wyzwanie, a znalezienie czasu to często cud. Jak często odkładasz swoje zdrowie na bok, skupiając się na rodzinie? Znam takie historie z pracy z mamami. Pamiętaj, że zdrowa mama to coś najważniejszego dla Twojego dziecka.",
    "Osoby z nadwagą i otyłością: Obawiasz BodyShame i czujesz dyskomfort? Ze mną nie musisz się martwić. Oferuję treningi w bezpiecznej atmosferze, dostosowane do Twoich możliwości. Sprawność to klucz do sprawczości.",
    'Osoby z bólem ostrym i przewlekłym: Szukasz skutecznych metod radzenia sobie z bólem? Nie wiesz, co będzie najlepsze? Walka z bólem to moja specjalność! Zajrzyj do zakładki "Projekty" i przekonaj się sam.',
    "Osoby po operacjach: kluczowe jest odpowiednie wsparcie w pełnym powrocie do zdrowia, od pierwszego dnia aż do 9-12 miesięcy po operacji. W tej podróży wiem, jak Cię poprowadzić, byś mógł bezpiecznie wrócić do codziennych aktywności. Zaufaj mi na tej drodze.",
    "Osoby z dyskopatią: to choroba cywilizacyjna, z którą pokażę Ci, jak skutecznie sobie radzić.",
    "Seniorzy: zachowaj sprawność i samodzielność dzięki podejściu, które pozwoli Ci nie martwić się o ciężary, zadyszkę na schodach czy kondycję podczas wycieczki na Malediwy. ",
    "Kobiety w ciąży: ciesz się tym wyjątkowym okresem. Pomogę Ci pozbyć się obrzęków, zgagi, bólu pleców i drętwienia rąk. Zadbam o Twoją kondycję, abyś mogła bez stresu myśleć o porodzie.",
    "Pracownicy biurowi: spędzasz wiele godzin za biurkiem? Brakuje motywacji do ruchu, a bóle pleców są coraz bardziej dokuczliwe? Mam na to rozwiązanie. Zadbamy o Twoją postawę, kondycję i dobre samopoczucie.",
  ],
  services1: [
    "Terapię manualną",
    "Igłoterapię",
    "Rehabilitację pourazową i pooperacyjną",
    "USG narządu ruchu",
    "Terapię kobiet w ciąży i po porodzie",
    "Zwalczanie bólu przewlekłego",
  ],
  services2: [
    "Trening medyczny",
    "Trening kobiet w ciąży i po porodzie",
    "Przygotowanie sportowe, do zawodów",
    "Trening personalny",
    "Przygotowanie sportowe, do zawodów",
    "Rehabilitacja ruchowa, pourazowa",
  ],
  image1: servicesImg2,
  image2: servicesImg1,
};
